import { createFileRoute } from "@tanstack/react-router";
import { Cpu } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { Models } from "@/features/governance/modules/governance/models";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/models/")({
  component: RouteComponent,
  loader: () => ({ crumb: m.models_title() }),
});

function RouteComponent() {
  return (
    <PageShell icon={Cpu} title={m.models_title()} description={m.models_description()}>
      <Models />
    </PageShell>
  );
}
